import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'

import { uploadFiles } from './uploadEventFiles'

export const useCreateEvent = ({ eventType, redirectFn }) => {
  const { t } = useTranslation(['eventManagement'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const createEvent = async (formData) => {
    setIsLoading(true)

    try {
      const jsonResponse = await uploadFiles(formData.image, formData.files)
      const toSave = { ...formData }
      delete toSave.image
      delete toSave.files

      await API.createNewEvent({ ...toSave, ...jsonResponse })
      displaySnackbar(t('eventManagement:common.eventCreated', { eventType, name: formData.name }))
      redirectFn()
    } catch {
      displaySnackbar(
        t('eventManagement:common.eventCreateError', { eventType, name: formData.name }),
        true,
      )
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, createEvent }
}
